// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: {
          name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () => import('@/components/information/broadcast.vue'),
    },
    {
        path: '/financing',
        name: 'financing',
        component: () => import('@/components/information/financing.vue'),
    },
    {
        path: '/interview',
        name: 'interview',
        component: () => import('@/components/information/interview.vue'),
    },
    {
        path: '/comments',
        name: 'comments',
        component: () => import('@/components/information/comments.vue'),
    },
    {
        path: '/drygoods',
        name: 'drygoods',
        component: () => import('@/components/information/drygoods.vue'),
    },
    {
        path: '/weekly',
        name: 'weekly',
        component: () => import('@/components/information/weekly.vue'),
    },
    {
        path: '/monthly',
        name: 'monthly',
        component: () => import('@/components/information/monthly.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () => import('@/components/information/project.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () => import('@/components/research/report.vue'),
    },
    {
        path: '/evaluation',
        name: 'evaluation',
        component: () => import('@/components/research/evaluation.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () => import('@/components/research/list.vue'),
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('@/components/research/policy.vue'),
    },
    {
        path: '/industry',
        name: 'industry',
        component: () => import('@/components/data/industry.vue'),
    },
    {
        path: '/exit',
        name: 'exit',
        component: () => import('@/components/data/exit.vue'),
    },
    {
        path: '/import',
        name: 'import',
        component: () => import('@/components/data/import.vue'),
    },
    {
        path: '/pay',
        name: 'pay',
        component: () => import('@/components/data/pay.vue'),
    },
    {
        path: '/logistics',
        name: 'logistics',
        component: () => import('@/components/data/logistics.vue'),
    },
    {
        path: '/financeData',
        name: 'financeData',
        component: () => import('@/components/data/financeData.vue'),
    },
    {
        path: '/monthlive',
        name: 'monthlive',
        component: () => import('@/components/data/monthlive.vue'),
    },
    {
        path: '/exposure',
        name: 'exposure',
        component: () => import('@/components/complaints/exposure.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () => import('@/components/complaints/complainList.vue'),
    },
    {
        path: '/rating',
        name: 'rating',
        component: () => import('@/components/complaints/rating.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router
